import React, { useRef, useLayoutEffect, useState } from 'react'

import { RouteComponentProps } from 'react-router'

import { useMediaContext } from 'src/context/responsive'
import { Footer } from 'src/layout/Footer'
import { Content } from 'src/refactor/structure'
import { Contact, Eligibility, UnderConstruction } from 'src/refactor/blocks'
import { useWatcher } from 'src/hooks'
import { useGlobalState } from 'src/context/global'
import classNames from 'classnames'
import {
  MainInfoSection,
  HeroSection,
  NetworkOfExcellence,
  Testimonials,
} from './components'
import { SearchBar } from './components/SearchBar'
import { VideoPlayer } from './components/VideoPlayer'
import { CentivoCareSection } from './components/CentivoCareSection'

export interface HomeViewProps extends RouteComponentProps {
  isBannerOpen?: boolean
}

export const Home: React.FC<HomeViewProps> = ({ location, isBannerOpen }) => {
  const { isMobileView } = useMediaContext()
  const contact = useRef<HTMLDivElement>(null)
  const [{ appConfig }] = useGlobalState()

  const {
    template,
    shouldShowHeader,
    shouldShowHero,
    shouldShowContactForm,
    shouldShowMainInfo,
    shouldShowNetworkOfExcellence,
    shouldShowEligibility,
    shouldShowSearch,
    shouldShowTestimonials,
    shouldShowVpc,
    shouldShowUnderConstruction,
    footerText,
    networkSelectionEnabled,
  } = appConfig

  const [videoPlayerOpen, setVideoPlayerOpen] = useState(false)

  const applyTemplate = () => {
    const homeClassName = `${template}--home`
    document.querySelector('html')?.classList.add(homeClassName)

    if (!shouldShowHeader) {
      document.querySelector('html')?.classList.add('header-hidden')
    }

    return () => document.querySelector('html')?.classList.remove(homeClassName)
  }
  useWatcher(
    applyTemplate,
    { template, shouldShowHeader },
    { shouldRunOnMount: true }
  )

  useLayoutEffect(() => {
    if (location.hash.includes('contact')) {
      contact.current?.scrollIntoView()
    }
    document.title = 'Centivo Provider Search'
  }, [location])

  const shouldShowHomeContent =
    shouldShowMainInfo ||
    shouldShowVpc ||
    shouldShowNetworkOfExcellence ||
    shouldShowSearch

  return (
    <main
      className={classNames(template, {
        'network-selection': networkSelectionEnabled,
        'banner-open': isBannerOpen,
      })}
    >
      <VideoPlayer isOpen={videoPlayerOpen} setIsOpen={setVideoPlayerOpen} />

      <div className="main-content">
        {shouldShowUnderConstruction && <UnderConstruction />}
        {!shouldShowUnderConstruction && (
          <>
            {shouldShowHero && (
              <Content className="hero-content">
                <HeroSection setVideoPlayerOpen={setVideoPlayerOpen} />
              </Content>
            )}
            {shouldShowEligibility && <Eligibility />}
            {shouldShowHomeContent && (
              <Content className="home-content">
                {shouldShowMainInfo && <MainInfoSection />}
                {shouldShowVpc && <CentivoCareSection />}
                {shouldShowNetworkOfExcellence && <NetworkOfExcellence />}
                {shouldShowSearch && <SearchBar />}
              </Content>
            )}
            {shouldShowTestimonials && <Testimonials />}
            {!isMobileView && shouldShowContactForm && (
              <Content className="contact-form" ref={contact}>
                <Contact.Section />
              </Content>
            )}
          </>
        )}
      </div>
      <Footer isBannerOpen={isBannerOpen}>
        {footerText && (
          <div
            className="content"
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{ __html: footerText }}
          />
        )}
      </Footer>
    </main>
  )
}
